/**
 * Validação de valor de saque no formulário (paridade com regras de UX do SaquePage).
 */

export function parseAmountInput(raw: string): number | null {
  const s = raw.trim().replace(/\s/g, '');
  if (!s) return null;
  let x = s.replace(/[^\d,.-]/g, '');
  if (!x || x === '.' || x === '-' || x === ',') return null;
  if (x.includes(',') && !x.includes('.')) {
    x = x.replace(',', '.');
  } else if (x.lastIndexOf(',') > x.lastIndexOf('.')) {
    x = x.replace(/\./g, '').replace(',', '.');
  } else {
    x = x.replace(/,/g, '');
  }
  const n = parseFloat(x);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100) / 100;
}

export function formatCurrencyBrl(v: number): string {
  return `R$ ${v.toFixed(2).replace('.', ',')}`;
}

export function validateWithdrawalAmount(
  maxAmount: number,
  raw: string
): { ok: true; value: number } | { ok: false; message: string } {
  if (!raw.trim()) {
    return { ok: false, message: 'Informe o valor do saque.' };
  }
  const v = parseAmountInput(raw);
  if (v === null || v <= 0) {
    return { ok: false, message: 'Informe um valor válido maior que zero.' };
  }
  const maxCents = Math.round(maxAmount * 100);
  const vCents = Math.round(v * 100);
  if (vCents > maxCents) {
    return {
      ok: false,
      message: `O valor não pode ultrapassar o saldo disponível (${formatCurrencyBrl(maxAmount)}).`,
    };
  }
  return { ok: true, value: vCents / 100 };
}
